import { getGlobalAllowedSearchParameters } from 'shared/lib/react-router-dom';
import { createNonce } from 'shared/services/local-storage';

const GOOGLE_OAUTH_ENDPOINT = 'https://accounts.google.com/o/oauth2/v2/auth';

export const signInWithGoogle = async (): Promise<void> => {
  const clientId = import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_GOOGLE_REDIRECT_URI;

  if (!clientId) {
    throw new Error('VITE_GOOGLE_WEB_CLIENT_ID is not set');
  }
  if (!redirectUri) {
    throw new Error('VITE_GOOGLE_REDIRECT_URI is not set');
  }

  const { hashed } = await createNonce();

  const state = encodeURIComponent(
    JSON.stringify({
      origin: window.location.origin,
      queryParams: Object.fromEntries(getGlobalAllowedSearchParameters()),
    }),
  );

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid email profile',
    nonce: hashed,
    state,
    prompt: 'select_account',
    access_type: 'online',
  });

  window.location.href = `${GOOGLE_OAUTH_ENDPOINT}?${params.toString()}`;
};
